var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code"},[_c('canvas',{ref:"canvas",attrs:{"id":"QRCode_header","title":"扫描二维码"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }